// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_shared_shared_module_ts":"c9c9e1c0b2ee3f25","src_app_learning-mode_learning-mode_module_ts":"613663998e8093e7","src_app_production-mode_production-mode_module_ts":"cacf8ccffe8575c5"}[chunkId] + ".js";
};